<div class="modal-container">
	<h2 mat-dialog-title>{{ data.title }}</h2>
	<mat-dialog-content>
		This will resend the intake form via email and/or SMS. Existing responses will not be affected.
	</mat-dialog-content>
	<br/>
	<mat-dialog-actions>
		<button mat-dialog-close mat-button>Cancel</button>
		<button mat-button cdkFocusInitial [mat-dialog-close]="true">Resend</button>
	</mat-dialog-actions>
</div>
